import { ApiUrlConfig, ApiEndpointConfig } from "@hrra/core";
import { ApiTypes } from "./api-types";

export interface UrlConfig {
  login: string;

  auth: {
    signIn: string;
    signOut: string;
    signInAsCustomer: string;
    signInToPublicPortal: string;
    refreshToken: string;
    userInfo: string;
  };

  currentUser: {
    info: string;
    menu: string;
  };
  lookup: {
    multi: {
      get: string;
    };
    occupationCategory: {
      list: string;
    };
  };
  configuration: {
    multi: {
      get: string;
    };
  };
  jobseeker: {
    list: string;
    get: string;
    save: string;
    delete: string;
    updateInternalEmployeeState: string;
    updarePreferredLanguage: string;
    getLocations: string;
    getModerationJobseeker: string;
    approveJobseekerModeration: string;
    rejectJobseekerModeration: string;
    getModerationCount: string;
    getJobseekerDetails: string;

    basicInfo: {
      save: string;
      resetPassword: string;
    };

    details: {
      save: string;
    };

    workExperience: {
      save: string;
      setWithoutExperience: string;
      delete: string;
      attachment: {
        download: string;
      };
    };

    education: {
      save: string;
      delete: string;
      attachment: {
        download: string;
      };
    };

    language: {
      save: string;
      attachment: {
        download: string;
      };
    };

    document: {
      download: string;
      delete: string;
    };

    event: {
      register: string;
      listOldAndCurrent: string;
    };

    subscription: {
      update: string;
    };
  };
  file: {
    upload: string;
  };
  customer: {
    list: string;
    listByName: string;
    get: string;
    save: string;
    delete: string;
    archive: string;
    getModerationCustomer: string;
    approveCustomerModeration: string;
    rejectCustomerModeration: string;
    getModerationCountStat: string;
    getCvBoxChannels: string;
    postCvBoxChannels: string;

    details: {
      save: string;
    };

    billing: {
      save: string;
      validate: string;
    };

    agents: {
      save: string;
      validate: string;
      resetPassword: string;
      activationLink: string;
      activate: string;
      deactivate: string;
      delete: string;
    };

    contracts: {
      save: string;
      delete: string;
    };

    events: {
      delete: string;
      list: string;
      listPackages: string;
      add: string;
      requestCvDatabaseAccess: string;
    };
    branding: {
      uploadTempFile: string;
      create: string;
      save: string;
    };
  };
  productPurchases: {
    cvdatabaseproduct: {
      request: {
        list: string;
        process: string;
      };
    };
    sliderbannerproduct: {
      request: {
        list: string;
        process: string;
      };
    };
    cvbox: {
      request: {
        list: string;
        process: string;
      };
    };
    branding: {
      request: {
        list: string;
        process: string;
      };
    };
  };

  subscribers: {
    list: string;
    delete: string;
  };

  announcements: {
    list: string;
    listFuture: string;
    activate: string;
    deactivate: string;
    cancel: string;
    terminate: string;
    capture: string;
    details: {
      get: string;
    };
    moderationRelatedAnnouncement: {
      get: string;
      approve: string;
      reject: string;
      announcementStat: string;
    };
  };

  store: {
    items: {
      list: string;
      listEventSpecific: string;
    };
  };

  statsandreports: {
    get: string;
    getAnnouncementsTotalsPerCustomer: string;
    getSalesReport: string;
    getUpgradesSalesReport: string;
    getCvDatabaseReport: string;
    getCvDatabaseClicksReport: string;
    getCvDatabaseInvitesDetail: string;
    getSuspendedEmails: string;
    processSuspendedEmail: string;
    announcementMatching: {
      announcementMatchingList: {
        get: string;
        approve: string;
        list: string;
        generateMatching: string;
        regenerateMatching: string;
        ExpressApprove: string;
      };
      announcementMatchingJobseeker: {
        approve: string;
      };
    };
    getIndexationReport: string;
  };
  salesAssistants: {
    list: string;
    save: string;
    delete: string;
  };

  portfolios: {
    get: string;
    getList: string;
    listAdminPortfolios: string;
    list: string;
    save: string;
    validate: string;
    accountManagers: {
      list: string;
      save: string;
    };
    details: {
      list: string;
      move: string;
    };
    history: {
      get: string;
    };
    editName: string;
  };

  transactions: {
    list: string;
    totals: string;
    payers: {
      list: string;
    };
    edit: string;
    sendConfirmation: string;
    getAccessiblePortfolios: string;
    approve: {
      initial: string;
      final: string;
    };
    reject: string;
  };

  invoices: {
    list: string;
    total: string;
    merge: string;
    unmerge: string;
    updateDate: string;
    updateAccounting: string;
    search: string;
    approve: string;
    sendInvoice: string;
  };

  accounts: {
    search: string;
  };

  payments: {
    list: string;
    totals: string;
    get: string;
    add: string;
    delete: string;
    edit: string;
  };

  billingReport: {
    list: string;
    totals: string;
  };

  comments: {
    FilterThreadsWithPreview: string;
    FilterThreadComments: string;
    AddComment: string;
    AddCommentToThread: string;
    DeleteComment: string;
  };

  settings: {
    templates: {
      list: string;
      get: string;
      create: string;
      edit: string;
      delete: string;
      approve: string;
    };
    smsEmailTemplates: {
      list: string;
    };
    systemConfiguration: {
      list: string;
    };
    adminUsers: {
      list: string;
      getPermissions: string;
      getLimitedOrUnlimiterRole: string;
      save: string;
      getAdmin: string;
      update: string;
      validateEmail: string;
      validateUsername: string;
    };
    infoPages: {
      getActiveProviderWebsites: string;
      getPrimaryAndAltLanguages: string;
      getTitleAndContent: string;
      updateStaticContent: string;
    };
    banners: {
      bannersManagePage: string;
      getBannerList: string;
      getBanner: string;
      edit: string;
      create: string;
      updateStatus: string;
      uploadTempFile: string;
      getBannerPosition: string;
    };
  };

  sales: {
    monthlyPlans: {
      getEmptyPlan: string;
      getEmptyPlanSpecific: string;
      getCurrentPlan: string;
      getPlan: string;
      create: string;
      edit: string;
      getReport: string;
    };
  };
}

export const urlConfig: UrlConfig = {
  login: '/signin',

  auth: {
    signIn: 'sign-in',
    signOut: 'signout',
    signInAsCustomer: 'login-to/customer-agent-{id}',
    signInToPublicPortal: 'login-to/public-website/{providerWebsiteId}',
    refreshToken: 'refresh-access-token',
    userInfo: 'user-info',
  },

  currentUser: {
    info: 'user-info',
    menu: 'menu-items',
  },
  lookup: {
    multi: {
      get: 'lookup/init',
    },
    occupationCategory: {
      list: 'lookup/occupationcategories',
    },
  },
  configuration: {
    multi: {
      get: 'configuration/init',
    },
  },
  jobseeker: {
    list: 'jobseekers',
    get: 'jobseekers/{id}',
    save: 'jobseekers/{id}/save',
    delete: 'jobseekers/{id}/delete',
    updateInternalEmployeeState: 'jobseekers/{id}/update-internal-employee-state',
    updarePreferredLanguage: 'jobseekers/{id}/preferred-language/save',
    getLocations: 'data/locations',
    getModerationJobseeker: 'jobseekers/moderation/{jobseekerId}',
    approveJobseekerModeration: 'jobseekers/moderation/{jobseekerModerationId}/approve',
    rejectJobseekerModeration: 'jobseekers/moderation/{jobseekerModerationId}/reject',
    getModerationCount: 'jobseekers/moderation-stats',
    getJobseekerDetails: 'jobseekers/{jobseekerId}/details',
    basicInfo: {
      save: 'jobseekers/{id}/basic-info/save',
      resetPassword: 'jobseekers/{id}/basic-info/reset-password',
    },
    details: {
      save: 'jobseekers/{id}/details/save',
    },
    workExperience: {
      save: 'jobseekers/{id}/work-experience/save',
      setWithoutExperience: 'jobseekers/{id}/work-experience/set-without-experience',
      delete: 'jobseekers/{id}/work-experience/delete',
      attachment: {
        download: 'jobseekers/{id}/work-experience/download',
      },
    },
    education: {
      save: 'jobseekers/{id}/education/save',
      delete: 'jobseekers/{id}/education/delete',
      attachment: {
        download: 'jobseekers/{id}/education/{educationId}/download',
      },
    },

    language: {
      save: 'jobseekers/{id}/language/save',
      attachment: {
        download: 'jobseekers/{id}/language/{languageId}/download',
      },
    },

    document: {
      download: 'jobseekers/{id}/document/{documentId}/download',
      delete: 'jobseekers/{id}/document/delete',
    },

    event: {
      register: 'jobseekers/{id}/events/{eventId}/register',
      listOldAndCurrent: 'jobseekers/events/get-past-and-current-events',
    },

    subscription: {
      update: 'jobseekers/{id}/subscription/update',
    },
  },
  file: {
    upload: 'file/upload',
  },
  customer: {
    list: 'customers',
    listByName: 'customers/list-by-name',
    get: 'customers/{id}',
    save: 'customers/{id}/save',
    delete: 'customers/{id}/delete',
    archive: 'customers/{id}/archive',
    getModerationCustomer: 'customers/moderation/{customerId}',
    approveCustomerModeration: 'customers/moderation/{customerModerationId}/approve',
    rejectCustomerModeration: 'customers/moderation/{customerModerationId}/reject',
    getModerationCountStat: 'customers/customer-stats',
    getCvBoxChannels: 'customers/{customerId}/cv-box-providers/get',
    postCvBoxChannels: 'customers/{customerId}/cv-box-providers/save',



    details: {
      save: 'customers/{id}/details/save',
    },
    billing: {
      save: 'customers/{id}/billing/save',
      validate: 'customers/billing/validate',
    },
    agents: {
      save: 'customers/agent/save',
      validate: 'customers/agent/validate',
      resetPassword: 'customers/{id}/agent/reset-password',
      activationLink: 'customers/{id}/agent/activationLink',
      activate: 'customers/agent/activate',
      deactivate: 'customers/agent/deactivate',
      delete: 'customers/agent/delete',
    },

    contracts: {
      save: 'customers/contract/save',
      delete: 'customers/contract/delete',
    },

    events: {
      delete: 'customers/{id}/events/delete',
      list: 'customers/events/list',
      listPackages: 'customers/events/packages',
      add: 'customers/events/add',
      requestCvDatabaseAccess: 'customers/events/request-cv-db-access',
    },

    branding: {
      uploadTempFile: 'customers/branding/upload-temp-file',
      create: 'customers/branding',
      save: 'customers/branding/save',
    },
  },
  productPurchases: {
    cvdatabaseproduct: {
      request: {
        list: 'product-purchases/cv-database-access-request/list',
        process: 'product-purchases/cv-database-access-request/{id}/process',
      },
    },
    sliderbannerproduct: {
      request: {
        list: 'product-purchases/slider-banner-request/list',
        process: 'product-purchases/slider-banner-request/{id}/process',
      },
    },
    cvbox: {
      request: {
        list: 'product-purchases/cv-box-request/list',
        process: 'product-purchases/cv-box-request/{id}/process',
      },
    },
    branding: {
      request: {
        list: 'product-purchases/customer-branding-request/list',
        process: 'product-purchases/customer-branding-request/{id}/process',
      },
    },
  },

  subscribers: {
    list: 'subscribers',
    delete: 'subscribers/{subscriberId}/delete',
  },

  announcements: {
    list: 'announcements',
    listFuture: 'announcements/future-announcements',
    activate: 'announcements/{id}/activate',
    deactivate: 'announcements/{id}/deactivate',
    cancel: 'announcements/{id}/cancel',
    terminate: 'announcements/{id}/terminate',
    details: {
      get: 'announcements/{id}/get-details',
    },
    capture: 'announcements/update-capture-cv',
    moderationRelatedAnnouncement: {
      get: 'announcements/{announcementId}/moderation',
      approve: 'announcements/moderation/{announcementModerationId}/approve',
      reject: 'announcements/moderation/{announcementModerationId}/reject',
      announcementStat: 'announcements/moderation-stats',
    },
  },
  store: {
    items: {
      list: 'store/items/list',
      listEventSpecific: 'store/event-items/list',
    },
  },

  statsandreports: {
    get: 'stats-and-reports/get-channel-announcement-stats',
    getAnnouncementsTotalsPerCustomer: 'stats-and-reports/get-announcements-totals-per-customer',
    getSalesReport: 'stats-and-reports/get-sales-report',
    getUpgradesSalesReport: 'stats-and-reports/get-upgrades-sales-report',
    getCvDatabaseReport: 'stats-and-reports/get-cv-database-report',
    getCvDatabaseClicksReport: 'stats-and-reports/get-cv-database-clicks-report',
    getCvDatabaseInvitesDetail: 'stats-and-reports/get-cv-database-invites-detail',
    getSuspendedEmails: 'stats-and-reports/get-suspended-emails',
    processSuspendedEmail: 'stats-and-reports/process-suspended-email',
    announcementMatching: {
      announcementMatchingList: {
        get: 'stats-and-reports/announcement-matching/get-announcement-matching-list',
        approve: 'stats-and-reports/announcement-matching/approve-announcement-matching-list',
        list: 'stats-and-reports/announcement-matching/list-announcement-matching',
        generateMatching: 'stats-and-reports/announcement-matching/generate/{announcementId}/{year}',
        regenerateMatching: 'stats-and-reports/announcement-matching/regenerate/{announcementId}/{year}',
        ExpressApprove: 'stats-and-reports/announcement-matching/express-approve',
      },
      announcementMatchingJobseeker: {
        approve: 'stats-and-reports/announcement-matching/approve-announcement-matching-jobseeker',
      },
    },
    getIndexationReport: 'stats-and-reports/indexation-report',
  },

  salesAssistants: {
    list: 'sales-assistant/{portfolioId}/list',
    save: 'sales-assistant/save',
    delete: 'sales-assistant/{portfolioSalesAssistantId}/remove',
  },

  portfolios: {
    get: 'portfolios/{id}',
    getList: 'portfolios/get-list',
    listAdminPortfolios: 'portfolios/list-admin-portfolios',
    list: 'portfolios/list',
    save: 'portfolios/save',
    validate: 'portfolios/validate',
    accountManagers: {
      list: 'portfolios/account-managers/list',
      save: 'portfolios/account-managers/save',
    },
    details: {
      list: 'portfolios/{id}/details',
      move: 'portfolios/{id}/move-customer',
    },
    history: {
      get: 'portfolios/{id}/history',
    },
    editName: 'portfolios/{id}/edit-name',
  },

  transactions: {
    list: 'billing/transactions/list',
    totals: 'billing/transactions/totals',
    payers: {
      list: 'billing/transactions/payers-list',
    },
    edit: 'billing/transactions/edit',
    sendConfirmation: 'billing/transactions/send-confirmation',
    getAccessiblePortfolios: 'billing/transactions/accessible-portfolios',
    approve: {
      initial: 'billing/transactions/approve-initial',
      final: 'billing/transactions/approve-final',
    },
    reject: 'billing/transactions/reject-unapproved',
  },

  invoices: {
    list: 'billing/invoices/list',
    total: 'billing/invoices/total',
    merge: 'billing/invoices/merge',
    unmerge: 'billing/invoices/unmerge',
    updateDate: 'billing/invoices/update-date',
    updateAccounting: 'billing/invoices/update-accounting',
    search: 'billing/invoices/search',
    approve: 'billing/invoices/approve',
    sendInvoice: 'billing/invoices/send-invoice',
  },

  accounts: {
    search: 'billing/accounts/search',
  },

  payments: {
    list: 'billing/payments/list',
    totals: 'billing/payments/totals',
    get: 'billing/payments/get',
    add: 'billing/payments/add',
    delete: 'billing/payments/delete',
    edit: 'billing/payments/edit',
  },

  billingReport: {
    list: 'billing/biling-report/list',
    totals: 'billing/biling-report/totals',
  },

  comments: {
    FilterThreadsWithPreview: 'comments/get-thread-previews',
    FilterThreadComments: 'comments/get-thread-comments',
    AddComment: 'comments/add',
    AddCommentToThread: 'comments/add-thread-comment',
    DeleteComment: 'comments/delete',
  },

  settings: {
    templates: {
      list: 'settings/templates/list',
      get: 'settings/templates/get',
      create: 'settings/templates/create',
      edit: 'settings/templates/edit',
      delete: 'settings/templates/delete',
      approve: 'settings/templates/approve',
    },
    smsEmailTemplates: {
      list: 'settings/email-sms-templates/list',
    },
    systemConfiguration: {
      list: 'settings/system-configuration',
    },
    adminUsers: {
      list: 'settings/admins/list',
      getPermissions: 'settings/admins/get-permissions',
      getLimitedOrUnlimiterRole: 'settings/admins/get-roles',
      save: 'settings/admins/new/save',
      getAdmin: 'settings/admins/get-admin',
      update: 'settings/admins/save-edit',
      validateEmail: 'settings/admins/validate-email',
      validateUsername: 'settings/admins/validate-username',
    },
    infoPages: {
      getActiveProviderWebsites: 'settings/list-provider-websites',
      getPrimaryAndAltLanguages: 'settings/get-provider-website-language',
      getTitleAndContent: 'settings/get-static-content',
      updateStaticContent: 'settings/update-static-content',
    },
    banners: {
      bannersManagePage: 'settings/banner-positions',
      getBannerList: 'settings/banner-list/{id}',
      getBanner: 'settings/get-banner/{positionId}/banners/{id}',
      edit: 'settings/edit-banner',
      create: 'settings/insert-banner',
      updateStatus: 'settings/edit-banner-status',
      uploadTempFile: 'settings/temp-file-upload',
      getBannerPosition: 'settings/banner-position/{id}',
    },
  },

  sales: {
    monthlyPlans: {
      getEmptyPlan: 'sales/get-empty-plan',
      getEmptyPlanSpecific: 'sales/get-empty-plan-specific',
      getCurrentPlan: 'sales/get-current-plan',
      getPlan: 'sales/get-plan',
      create: 'sales/create-new-plan',
      edit: 'sales/edit-plan',
      getReport: 'sales/get-plan-report',
    },
  },
};

export interface UrlConfigContainer extends ApiEndpointConfig {
  api: ApiUrlConfig<UrlConfig>;
}

export const adminUrlConfig: UrlConfigContainer = {
  api: {
    apiType: ApiTypes.AdminApi,
    data: urlConfig
  }
};
